
        var result = require("!!../../../../../node_modules/mini-css-extract-plugin/dist/loader.js!../../../../../node_modules/css-loader/index.js??ref--8-2!../../../../../node_modules/sass-loader/dist/cjs.js??ref--8-3!./data-entry-header.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    